import { create } from 'zustand';
import type { AuditorSession } from '@grc/shared';

interface AuditorAuthStore {
  session: AuditorSession | null;
  sessionToken: string | null;
  isAuditorAuthenticated: boolean;

  login: (sessionToken: string, session: AuditorSession) => void;
  logout: () => void;
}

export const useAuditorAuthStore = create<AuditorAuthStore>((set) => ({
  session: null,
  sessionToken: null,
  isAuditorAuthenticated: false,

  login: (sessionToken, session) => {
    set({ sessionToken, session, isAuditorAuthenticated: true });
  },

  logout: () => {
    set({ session: null, sessionToken: null, isAuditorAuthenticated: false });
  },
}));
